import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { FaRegEdit, FaRegEye } from "react-icons/fa";
import { RiDeleteBin6Line, RiExchangeFundsLine } from "react-icons/ri";

const DetailsConsultant = ({
  onClose,
  position,
  onDeleteClick,
  onEditClick,
  onTransferClick,
  onViewClick,
}) => {
  const modalRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  return createPortal(
    <div
      className="absolute z-50"
      style={{
        top: position?.top ?? 0,
        left: position?.left ?? 0,
      }}
    >
      <div
        ref={modalRef}
        className="bg-white shadow-2xl flex flex-col items-center gap-3 p-3 rounded-md border border-gray-200 w-32"
      >
        <button
          className="flex items-center gap-2 text-blue-600 hover:text-blue-800 w-full text-sm"
          onClick={onEditClick}
        >
          <FaRegEdit size={16} />
          Edit
        </button>

        <button
          className="flex items-center gap-2 text-red-600 hover:text-red-800 w-full text-sm"
          onClick={onDeleteClick}
        >
          <RiDeleteBin6Line size={16} />
          Delete
        </button>

        <button
          className="flex items-center gap-2 text-gray-600 hover:text-gray-800 w-full text-sm"
          onClick={onViewClick}
        >
          <FaRegEye size={16} />
          View
        </button>

        <button
          className="flex items-center gap-2 text-indigo-600 hover:text-indigo-800 w-full text-sm"
          onClick={onTransferClick}
        >
          <RiExchangeFundsLine size={16} />
          Transfer
        </button>
      </div>
    </div>,
    document.body
  );
};

export default DetailsConsultant;
